import { Routes } from '@angular/router';
import { Login } from '@app/features/auth/pages/login/login';
import { ResetPassword } from '@app/features/auth/pages/reset-password/reset-password';
import { authGuard } from '@app/core/auth/guards/auth.guard';
import { nonAuthGuard } from './core/auth/guards/non-auth.guard';
import { GuestLayout } from './layouts/guest-layout/guest-layout';
import { APP_ROUTES } from './core/constants/routes.constants';
import { MainLayout } from './layouts/main-layout/main-layout';
import { GuestHome } from './features/guest/pages/home/guest-home';
import { AuthLayout } from './layouts/auth-layout/auth-layout';
import { UnauthorizedComponent } from './features/common/components/unauthorized.component';
import { QrBased } from './features/common/pages/qr-based/qr-based';
import { QuestionnairePreview } from './features/questionnaire/pages/questionnaire-preview/questionnaire-preview';
import { RequestDemo } from './features/guest/pages/request-demo/request-demo';

export const routes: Routes = [
  // Redirect empty path to /home
  //  { path: '', pathMatch: 'full', redirectTo: 'home' },

  //   // Protected
  //   { path: 'home', component: Home, canActivate: [authGuard] },

  //   // Public
  //   { path: 'login', component: Login, canActivate: [nonAuthGuard] },
  //   { path: 'signup', component: SignupComponent, canActivate: [nonAuthGuard] },
  //   { path: 'reset-password', component: ResetPassword, canActivate: [nonAuthGuard] },

  //   { path: '**', redirectTo: 'home' }
  {
    path: APP_ROUTES.GUEST.ROOT,
    component: GuestLayout,
    canActivate: [nonAuthGuard],
    loadChildren: () => import('@features/guest/guest.routes').then((m) => m.GUEST_ROUTES),
  },
  {
    path: APP_ROUTES.GUEST.REQUEST_DEMO,
    canActivate: [nonAuthGuard],
    component: RequestDemo,
  },
  {
    path: APP_ROUTES.AUTH.ROOT,
    component: AuthLayout,
    canActivate: [nonAuthGuard],
    loadChildren: () => import('@features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: APP_ROUTES.WORKSPACE.ROOT,
    component: MainLayout,
    canActivate: [authGuard],
    loadChildren: () =>
      import('@features/workspace/workspace.routes').then((m) => m.WORKSPACE_ROUTES),
  },
  {
    path: APP_ROUTES.SETUP.ROOT,
    canActivate: [authGuard],
    component: MainLayout,
    loadChildren: () => import('@features/setup/setup.routes').then((m) => m.SETUP_ROUTES),
  },
  {
    path: APP_ROUTES.WORKSPACE.ROOT + '/' + APP_ROUTES.WORKSPACE.QUESTIONNAIRE.ROOT,
    canActivate: [authGuard],
    component: MainLayout,
    loadChildren: () =>
      import('@features/questionnaire/questionnaire.routes').then((m) => m.QUESTIONNAIRE_ROUTES),
  },
  {
    path: APP_ROUTES.WORKSPACE.ROOT + '/' + APP_ROUTES.WORKSPACE.REPORTS,
    canActivate: [authGuard],
    component: MainLayout,
    loadChildren: () => import('@features/reports/report.routes').then((m) => m.REPORT_ROUTES),
  },
  // {
  //   path: APP_ROUTES.SELF_ONBOARDING.ROOT,
  //   component: MainLayout,
  //   canActivate: [authGuard],
  //   loadChildren: () =>
  //     import('@features/onboarding/self-onboarding.routes').then((m) => m.SELF_ONBOARDING_ROUTES),
  // },
  {
    path: APP_ROUTES.MY_ACCOUNT.ROOT,
    canActivate: [authGuard],
    component: MainLayout,
    loadChildren: () =>
      import('@features/my-account/my-account.routes').then((m) => m.MY_ACCOUNT_ROUTES),
  },
  // {
  //   path: APP_ROUTES.ADMIN.ROOT,
  //   component: AdminLayout,
  //   loadChildren: () => import('@features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
  // },
  {
    path:
      APP_ROUTES.WORKSPACE.ROOT +
      '/' +
      APP_ROUTES.WORKSPACE.QUESTIONNAIRE.ROOT +
      '/' +
      APP_ROUTES.WORKSPACE.QUESTIONNAIRE.PREVIEW +
      '/:id',
    canActivate: [authGuard],
    component: QuestionnairePreview,
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: 'survey/:organizationId/:questionnaireId/:token',
    component: QrBased,
  },
  {
    path: '**',
    redirectTo: '', // redirect unknown paths to home
    pathMatch: 'full',
  },
];
